export const TwitterIcon = ({ className }: { readonly className: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.02583 2.5L8.21333 10.7733L1.98666 17.5H3.38833L8.84 11.61L13.2442 17.5H18.0133L11.4775 8.76083L17.2733 2.5H15.8717L10.8517 7.92333L6.795 2.5H2.02583ZM4.08666 3.53167H6.27833L15.9517 16.4675H13.7608L4.08666 3.53167Z"
        fill="currentColor"
      />
    </svg>
  );
};
